// frontend/src/hooks/useAuth.js

import { useState, useEffect, createContext, useContext } from 'react';
import { apiClient } from '../apiClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const response = await apiClient.getUser();
      setUser(response.user);
    } catch (error) {
      console.error('Error checking user:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const signIn = async (email, password) => {
    try {
      const response = await apiClient.signIn(email, password);
      setUser(response.user);
      return { data: response, error: null };
    } catch (error) {
      return { data: null, error: { message: error.message } };
    }
  };

  const signUp = async (email, password, firstName, lastName) => {
    try {
      const response = await apiClient.signUp(email, password, firstName, lastName);
      setUser(response.user);
      return { data: response, error: null };
    } catch (error) {
      return { data: null, error: { message: error.message } };
    }
  };

  const signOut = async () => {
    try {
      await apiClient.signOut();
      setUser(null);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const value = {
    user,
    loading,
    signIn,
    signUp,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
